import { render, staticRenderFns } from "./OpenBookedLesson.vue?vue&type=template&id=3bf47475&"
import script from "./OpenBookedLesson.vue?vue&type=script&lang=js&"
export * from "./OpenBookedLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports